// 报告跨 tab 同步 / Cross-tab report update broadcasting.
// 用于 regenerate 报告成功时，把已打开的旧 report 浏览页切换到新 report URL，
// 以及让同源 tab 内的 task detail 按钮同步新的 reportId。
// Used when regenerate succeeds: redirect any open old-report tab to the new
// reportId URL and sync the Open Report button inside the task detail modal.

const CHANNEL_NAME = "ripple-reports";

export interface ReportUpdatedMessage {
  type: "report-updated";
  simulationId: string;
  oldReportId: string;
  newReportId: string;
}

type BroadcastPayload = ReportUpdatedMessage;

function openChannel(): BroadcastChannel | null {
  try {
    if (typeof globalThis.BroadcastChannel !== "function") return null;
    return new BroadcastChannel(CHANNEL_NAME);
  } catch {
    return null;
  }
}

/** 发送 report-updated 事件 / Emit a report-updated broadcast. */
export function notifyReportUpdated(
  detail: Omit<ReportUpdatedMessage, "type">,
): void {
  const channel = openChannel();
  if (!channel) return;
  const message: ReportUpdatedMessage = { type: "report-updated", ...detail };
  try {
    channel.postMessage(message);
  } finally {
    channel.close();
  }
}

/** 订阅 report-updated 事件，返回 unsubscribe 函数 / Subscribe; returns unsubscribe. */
export function subscribeReportUpdates(
  handler: (message: ReportUpdatedMessage) => void,
): () => void {
  const channel = openChannel();
  if (!channel) return () => {};
  const listener = (event: MessageEvent<BroadcastPayload>) => {
    const data = event.data;
    if (data && data.type === "report-updated") {
      handler(data);
    }
  };
  channel.addEventListener("message", listener);
  return () => {
    channel.removeEventListener("message", listener);
    channel.close();
  };
}
